import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
// import { Link, useLocation } from 'react-router-dom';


const Sidebar = ({isMenuCollapsed}) => {

    const location = useLocation();
    const currentPath = location.pathname;

    const isActive = (path) => currentPath === path ? 'active' : '';


    return (
        < >

            <div class="flapt-sidemenu-wrapper">

                <div class="flapt-logo">
                    <a href="/">
                        <img class="desktop-logo" style={{ maxHeight: 65, marginTop: '6px' }} src="/admin_codebase/img/core-img/b-logo1.png" alt="Desktop Logo" />
                        <img class="small-logo" src="/admin_codebase/img/core-img/small-logo.png" alt="Mobile Logo" />
                    </a>

                    {/* <a href="/">                        
                        <span style={{fontSize:"22px",fontWeight:"bolder", color:"#fff"}}>Admin Panel</span>
                    </a> */}
                </div>
                <br />

                <div class="flapt-sidenav" id="flaptSideNav">

                    <div class="side-menu-area sidebar-scrollable">

                        <nav>
                            <ul class="sidebar-menu p-0" data-widget="tree">
                                <br />

                                <li className={isActive('/admin/dashboard')}>
                                    <Link to="/admin/dashboard"><i
                                    class='bx bx-grid-alt'></i>{!isMenuCollapsed && <span>Dashboard</span>}</Link>
                                </li>

                                {/* <li className={isActive('/admin/cust_management')}>
                                    <Link to="/admin/cust_management"><i class='bx bx-user-pin'></i>
                                    {!isMenuCollapsed && <span>Customer Management</span>}</Link>
                                </li> */}

                                <li className={isActive('/admin/customerlist')}>
                                    <Link to="/admin/customerlist"><i class='bx bx-store'></i>
                                    {!isMenuCollapsed && <span>Vendor</span>}</Link>
                                </li>

                                <li className={isActive('/admin/package')}>
                                    <Link to="/admin/package"><i class='bx bx-cube'></i>
                                    {!isMenuCollapsed && <span>Package</span>}</Link>
                                </li>

                                {/* <li className={isActive('/admin/vendor')}>
                                    <Link to="/admin/vendor"><i class='bx bx-store'></i>
                                    {!isMenuCollapsed && <span>Vendor</span>}</Link>
                                </li> */}


                                <li class="menu-header-title fw-bold" style={{fontSize:15}}>Reports</li>
                                <li className={isActive('/admin/reports')}>
                                    <Link to="/admin/reports"><i class='bx bx-bar-chart-alt-2'></i>
                                    {!isMenuCollapsed && <span>Bulk Reports</span>}</Link>
                                </li>                                

                                <li className={isActive('/admin/logout')}>
                                    <Link to="/admin/logout"><i class='bx bx-log-out-circle'></i>
                                    {!isMenuCollapsed && <span>Logout</span>}</Link>
                                </li>





                                {/* <li class="treeview"><Link to="/shop"><i class="bx bxs-cart"></i>Shop<i class="fa fa-angle-right"></i></Link>

                                    <ul class="treeview-menu">
                                        <li><Link to="/coins">Coins</Link></li>
                                        <li><Link to="/shopmodels">Shop models</Link></li>
                                    </ul>
                                </li> */}

                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />




                            </ul>
                        </nav>
                    </div>
                </div>
            </div >

        </>
    );
};

export default Sidebar;

